import { render, staticRenderFns } from "./AwsFilesInfoModal.vue?vue&type=template&id=463c5997&scoped=true"
import script from "./AwsFilesInfoModal.vue?vue&type=script&lang=ts"
export * from "./AwsFilesInfoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463c5997",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('463c5997')) {
      api.createRecord('463c5997', component.options)
    } else {
      api.reload('463c5997', component.options)
    }
    module.hot.accept("./AwsFilesInfoModal.vue?vue&type=template&id=463c5997&scoped=true", function () {
      api.rerender('463c5997', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aws-files-modules/AwsFilesInfoModal.vue"
export default component.exports